import * as React from 'react';
import { DashboardView } from './dashboard-view';
import useRestService from '../../shared/rest-service';
import * as styles from './dashboard.module.scss';
import { Link } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';

interface DashboardEntryProps {
  dashboard: DashboardView;
}

const DashboardEntry = (props: DashboardEntryProps) => {
  const { oktaAuth } = useOktaAuth();
  const { baseURL } = useRestService();
  const accessToken = oktaAuth.getAccessToken();

  return (
    <div className={styles.dashboard}>
      <h5>{props.dashboard.name}</h5>
      <div className={styles.reportList}>
        {props.dashboard.reports.map((report) => {
          return report.reportContentViewModels.map((reportContentViewModel) => {
            return reportContentViewModel.children.map((childViewModel) => {
              if (
                childViewModel.desktopTableauViewType === null ||
                childViewModel.desktopTableauViewType.workbook === null
              ) {
                return;
              }

              const workbookId = childViewModel.desktopTableauViewType.workbook.id;
              const viewId = childViewModel.desktopTableauViewType.id;

              return (
                <div key={`report-${report.reportId}`} className={styles.report}>
                  <Link to={`/reports/${report.reportId}`} key={`${report.reportId}`}>
                    <div className={styles.mask} />
                    <div className={styles.nameOverlay}>{childViewModel.name}</div>
                    <img
                      src={`${baseURL}api/tableauapi/previewviews/${report.clientId}/${workbookId}/${viewId}?accessToken=${accessToken}`}
                    />
                  </Link>
                </div>
              );
            });
          });
        })}
      </div>
    </div>
  );
};
export default DashboardEntry;
